<template>
  <div class="font-semibold mt-5 text-justify text-sm xl:text-base">
    <span v-html="$t('aboutMe')"></span>
  </div>
</template>
